import { pluralize, singularize, titleize, underscore } from 'inflection';
import * as Conventions from './conventions.js';
import * as Rule from './rule.js';
import * as Definitions from './definitions.js';
export function filterByType(styles, type) {
    return styles.filter((s) => Rule.isOfType(s, type));
}
export function filterByInstanceId(styles, instanceId) {
    return styles.filter((s) => s.details.instanceId == instanceId);
}
export const findByTypeAndId = (rules, type, id) => findById(rules, id);
export const findById = (rules, id) => rules.find((s) => s.details.id === id);
export const findBlank = (rules, type) => findByTypeAndId(rules, type, `blank-${type}`);
export const findBlankId = (styles, type) => { var _a; return (_a = findBlank(styles, type)) === null || _a === void 0 ? void 0 : _a.details.id; };
export function findStyle(styles, style) {
    return styles.find((s) => s.details.id == style.details.id);
}
export function findBySlug(styles, type, slug) {
    return styles.find((s) => s.type == type && s.details.slug == slug);
}
export function findByClassName(styles, className) {
    return styles.find((s) => Rule.getClassName(s) == className);
}
export function filterByCollectionId(styles, collectionId) {
    return styles.filter((s) => s.details.collectionId == collectionId);
}
export function filterCollectionsForType(styles, type) {
    return filterByType(styles, 'collection').filter((s) => s.props.type == type);
}
export function getDefaultCollections(styles) {
    return filterByType(styles, 'collection').filter((style) => style.details.isInternal);
}
export function getElementDefinitions(styles) {
    return filterByType(styles, 'collection')
        .filter((s) => (s.props.type == 'text' || s.props.type == 'block' || s.props.type == 'inline') && !s.details.isInternal)
        .map((s) => {
        var placeholder;
        const type = s.props.type;
        if (type == 'inline') {
            placeholder = 'Inline element';
        }
        else if (type == 'text') {
            placeholder = titleize(underscore(singularize(type)));
        }
        const name = Rule.getEffectiveSlug(s, styles);
        const description = s.details.description;
        return {
            label: Conventions.getLabelByName(s.details.slug),
            name: s.details.slug,
            id: s.details.id,
            description,
            isCustom: true,
            type: type,
            htmlTagName: null,
            isImplicit: false,
            title: pluralize(s.details.title),
            placeholder,
            className: `-${type}--${name}`
        };
    })
        .concat(Definitions.all);
}
// Merges two sets of styles. If style exists in both collection, prefers one from second
export function join(styles, contextStyles) {
    return styles
        .map((style) => contextStyles.find((r) => r.details.id == style.details.id) || style)
        .concat(contextStyles.filter((r) => !styles.find((s) => s.details.id == r.details.id)));
}
export function getAspectDefault(styles) {
    return styles[0];
}
export function getAspectDefaultOriginal(styles, options) {
    return findStyle(styles, getAspectDefault(options));
}
export function getAspectCustomizationType(styles, style, options) {
    const defaultStyle = getAspectDefaultOriginal(styles, options);
    return style.details.instanceId
        ? 'oneOff'
        : style.details.id === (defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.details.id)
            ? 'default'
            : options.find((s) => s.details.id === style.details.id)
                ? 'allowed'
                : 'nonAllowed';
}
/** Return element rule corresponding to given combo id */
export function findElementByComboId(styles, comboId) {
    return findElementByThemeAndComboId(styles, findThemeByComboId(styles, comboId), comboId);
}
/** Return theme where there is exists a combo with given id */
export function findThemeByComboId(styles, comboId) {
    for (const theme of filterByType(styles, 'theme')) {
        const category = Object.keys(theme.props).find((prop) => theme.props[prop].find((c) => c.id === comboId));
        if (category)
            return theme;
    }
    return null;
}
/** Return theme where there is exists a combo with given id */
export function findCombo(styles, comboId) {
    var _a;
    return (_a = Rule.findComboInTheme(findThemeByComboId(styles, comboId), comboId)) !== null && _a !== void 0 ? _a : null;
}
/** In given theme find a combo with given id */
export function findElementByThemeAndComboId(styles, theme, comboId) {
    if (!theme)
        return;
    const category = Object.keys(theme.props).find((prop) => theme.props[prop].find((c) => c.id === comboId));
    if (!category)
        return null;
    const combo = theme.props[category].find((c) => c.id === comboId);
    return findById(styles, combo.refId);
}
//# sourceMappingURL=set.js.map